// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b21fdfe2","455":"87747576"}[chunkId] + ".chunk.js";
};